import React from "react";

const HcContext = React.createContext({});
HcContext.displayName = "HcContext";

export default HcContext;
